// extracted by mini-css-extract-plugin
module.exports = {"container":"NetworkError_container__3tr9r","content":"NetworkError_content__1wRkY","top-text":"NetworkError_top-text__2nFQC","bottom-text":"NetworkError_bottom-text__1g2sA"};